import { render, staticRenderFns } from "./AliPlayer.vue?vue&type=template&id=58ad61a0&scoped=true&"
import script from "./AliPlayer.vue?vue&type=script&lang=js&"
export * from "./AliPlayer.vue?vue&type=script&lang=js&"
import style0 from "./AliPlayer.vue?vue&type=style&index=0&id=58ad61a0&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ad61a0",
  null
  
)

export default component.exports